import { useEffect, useState } from "react";
import { getGalleryInner } from "../Service/Api";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
const Gallery = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const Year = `${currentYear}`;
    setSelectedYear(Year);
    console.log("get current Year", Year);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const galleryData1 = await getGalleryInner();
      const galleryData = galleryData1.filter(
        (item) => item.category === "PhotoGallery",
      );
      setData(galleryData);

      const yearsSet = new Set();
      const monthsSet = new Set();
      galleryData.forEach((item) => {
        if (item.date) {
          const date = new Date(item.date);
          yearsSet.add(date.getFullYear());
          monthsSet.add(date.getMonth());
        }
      });

      const uniqueYearRanges = Array.from(yearsSet).sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);

      const monthOptions = Array.from(monthsSet)
        .sort((a, b) => a - b)
        .map((month) => monthNames[month]);
      setMonthOptions(["All", ...monthOptions]);
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;

    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const date = new Date(itemDate);
          const year = date.getFullYear();
          const month = date.getMonth();
          return (
            year === parseInt(selectedYear) &&
            (selectedMonth === "All" || monthNames[month] === selectedMonth)
          );
        }
        return false;
      });

      // If no data for the current year, reset to show all years
      if (filteredData.length === 0) {
        setSelectedYear("All");
        return;
      }
    } else if (selectedMonth !== "All") {
      filteredData = filteredData.filter((item) => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const month = new Date(itemDate).getMonth();
          return monthNames[month] === selectedMonth;
        }
        return false;
      });
    }

    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    // Sort the filtered data by date in descending order
    filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));

    setFilteredData(filteredData);
  }, [selectedYear, selectedMonth, searchQuery, data]);

  // useEffect(() => {
  //     const formattedDates = filterData.map((item) => {
  //         const dateObj = new Date(item.fromDate);
  //         const month = dateObj.getMonth() + 1; // getMonth() returns zero-based index (0 for January)
  //         const day = dateObj.getDate();
  //         const formattedDate = `${month}-${day}`;
  //         return formattedDate;
  //     });

  //     console.log(formattedDates); // Just an example, you can use formattedDates as needed
  // }, [filterData]);
  // const handleModal = id => {
  //     navigate(`/SubGallery?id=${id}`);
  // };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const emptyArray = [
    {
      description:
        "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.",
    },
  ];

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Gallery </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Gallery </h1>
            </div>
          </div>
          <div className="row tabs-dynamic">
            <div className="col-md-3">
              <div className="count-val">
                <p>Total Count: {filterData.length}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="month-selection">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value="All">All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="monthSelect"
                >
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>
          <div className="row years year2023 showYear">
            {filterData.length > 0
              ? filterData.map((item, index) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount "
                    data-month="1"
                    key={index}
                  >
                    <div className="gallery-inner">
                      <div className="gallery-blk">
                        <div className="backDiv"></div>
                        <LazyLoad
                          offset={10}
                          placeholder={
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/sld3.jpg"
                              alt="Loading..."
                              className="img-fluid"
                            />
                          }
                        >
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments[0]}`}
                            className="img-fluid"
                            alt="Gandhi High School, Sidhi, MP"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-content">
                        <div className="gallery-date">
                          {/* <h6>{(new Date(item.date).getDate)} {new Date(item.date).getDMonth} </h6> */}
                          <h6>
                            {new Date(item.date).getDate()}{" "}
                            {new Date(item.date).toLocaleString("default", {
                              month: "short",
                            })}
                          </h6>
                        </div>
                        <div className="gallery-title">
                          <h3>{item.title}</h3>
                          <p>{item.description}</p>
                        </div>
                        <div className="gall-num">
                          <h6>
                            <span>Number Of Photos :</span>{" "}
                            {item?.attachments.length}
                          </h6>
                        </div>

                        <Link
                          to={`/SubGallery?id=${item._id}`}
                          className="view-more"
                        >
                          View More <i className="bi bi-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              : emptyArray.map((data, index) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount"
                    data-month="1"
                  >
                    <div className="gallery-inner">
                      <div className="gallery-blk">
                        <div className="backDiv"></div>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/gallery.jpg"
                          alt="Gandhi High School, Sidhi, MP"
                        />
                      </div>
                      <div className="gallery-content">
                        <div className="gallery-date">
                          <h6>
                            30<span> Sep </span>{" "}
                          </h6>
                        </div>
                        <div className="gallery-title">
                          <h3>Gallery Title</h3>
                          <p>Description</p>
                        </div>
                        <div className="gall-num">
                          <h6>
                            <span>Number Of Photos :</span> 04
                          </h6>
                        </div>

                        <Link to="/SubGallery" className="view-more">
                          View More <i className="bi bi-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
            {/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount" data-month="2">
           <div className="gallery-inner">
           <div className="gallery-blk">
               <div className="backDiv"></div>
               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/gallery.jpg" alt="Gandhi High School, Sidhi, MP" />
           </div>
           <div className="gallery-content">
           <div className="gallery-date">
                   <h6>30<span>  Sep </span> </h6>
               </div>
               <div className="gallery-title">
                   <h3>Gallery Title</h3>
                    <p>Description</p>
               </div>
               <div className="gall-num">
                   <h6><span>Number Of Photos :</span> 04</h6>
               </div>
               
                <Link to="/SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
           </div>
       </div>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount" data-month="2">
           <div className="gallery-inner">
           <div className="gallery-blk">
               <div className="backDiv"></div>
               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/gallery.jpg" className="img-fluid" alt="Gandhi High School, Sidhi, MP" />
           </div>
           <div className="gallery-content">
           <div className="gallery-date">
                   <h6>30<span>  Sep </span> </h6>
               </div>
               <div className="gallery-title">
                   <h3>Gallery Title</h3>
                    <p>Description</p>
               </div>
               <div className="gall-num">
                   <h6><span>Number Of Photos :</span> 04</h6>
               </div>
               
                <Link to="/SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
           </div>
       </div>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount" data-month="2">
           <div className="gallery-inner">
           <div className="gallery-blk">
               <div className="backDiv"></div>
               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/gallery.jpg" alt="Gandhi High School, Sidhi, MP" />
           </div>
           <div className="gallery-content">
           <div className="gallery-date">
                   <h6>30<span>  Sep </span> </h6>
               </div>
               <div className="gallery-title">
                   <h3>Gallery Title</h3>
                    <p>Description</p>
               </div>
               <div className="gall-num">
                   <h6><span>Number Of Photos :</span> 04</h6>
               </div>
               
                <Link to="/SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
           </div>
       </div>
       </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount" data-month="2">
           <div className="gallery-inner">
           <div className="gallery-blk">
               <div className="backDiv"></div>
               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/gallery.jpg" alt="Gandhi High School, Sidhi, MP" />
           </div>
           <div className="gallery-content">
           <div className="gallery-date">
                   <h6>30<span>  Sep </span> </h6>
               </div>
               <div className="gallery-title">
                   <h3>Gallery Title</h3>
                    <p>Description</p>
               </div>
               <div className="gall-num">
                   <h6><span>Number Of Photos :</span> 04</h6>
               </div>
               
                <Link to="/SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
           </div>
       </div>
       </div>
       <div className="load-more">
           <div className="next">Show More</div>
       </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
